import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteAddonCategoryProps extends ModalEditComponentProps { }

const ModalDeleteAddonCategory: React.FC<ModalDeleteAddonCategoryProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/category/deleteCategory',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteCategory', '¿Seguro quieres eliminar esta categoría?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteAddonCategory